import { reportErrorMessage } from "utils/ErrorReporting"

export function contentValidator(source: string, customMarkdownTags: string[]) {
  if (!source) {
    return null
  }
  const invalidOpeningTags = {
    "<linkToModal": "<LinkToModal",
    "<modalFromLink": "<ModalFromLink",
    "<calloutBox": "<CalloutBox",
    "<emptyBr": "<EmptyBr"
  }
  customMarkdownTags.forEach((markdownTag) => {
    const openingCarat = "<"
    const downCasedMarkdownTag = markdownTag.charAt(0).toLowerCase() + markdownTag.slice(1)
    // @ts-expect-error TS7053
    invalidOpeningTags[openingCarat + downCasedMarkdownTag] = openingCarat + markdownTag
  })
  let validatedSource = source

  Object.keys(invalidOpeningTags).forEach((invalidTag) => {
    if (validatedSource.includes(invalidTag)) {
      // @ts-expect-error TS7053
      validatedSource = validatedSource.replace(invalidTag, invalidOpeningTags[invalidTag])
      // @ts-expect-error TS7053
      reportErrorMessage(`Replaced an invalid markdown tag "${invalidTag}" with "${invalidOpeningTags[invalidTag]}`)
    } else {
      return null
    }
  })
  return validatedSource
}
